import React, { useState, useEffect } from 'react';
import axios, { AxiosError } from 'axios';
import { ListGroup, Alert } from 'react-bootstrap';

import { useTranslation } from 'react-i18next';
import { authAPIRoutes } from '../../../app/constants';
import utils from '../../../app/domain/utils';
import QueryIndicator from '../../../app/components/QueryIndicator';
import Button from '../../../app/components/Button';

interface Document {
  front: string;
  back: string;
}

interface ResponseData {
  user: string;
  documents: Document;
}

const CDDUserDocuments = ({ userKey, eventNamePrefix }: {
  userKey: string,
  eventNamePrefix: string
}) => {
  const [data, setData] = useState<ResponseData | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<AxiosError | null>(null);

  const { t } = useTranslation();

  useEffect(() => {
    const apiUrl = process.env.REACT_APP_API_URL + authAPIRoutes.CDDUserDocuments.replace('{userKey}', userKey);
    const fetchData = async () => {
      try {
        const response = await axios.get<ResponseData>(apiUrl);
        setData(response.data);
        setLoading(false);
      } catch (err) {
        setError(err as AxiosError);
        setLoading(false);
      }
    };

    fetchData();
  }, [userKey]);

  const handleDownload = (url: string) => {
    utils.openLinkInNewWindow(url);
  };

  if (loading) {
    return (
      <QueryIndicator />
    );
  }

  if (error) {
    return (<Alert variant="danger">{error.message}</Alert>);
  }

  return (
    <div className="container mt-5">
      <h1 className="mb-4">{`Documents de ${data?.user}`}</h1>
      <ListGroup>
        {data?.documents && Object.entries(data.documents).map(([docKey, url]) => (
          <ListGroup.Item key={docKey} className="d-flex justify-content-between align-items-center">
            <span>{t(`CDDUserDocuments.${docKey}`)}</span>
            <Button
              variant="primary"
              onClick={() => handleDownload(url)}
              trackingEvent={`${eventNamePrefix}.doc.download.click`}
              title={t('CDDUserDocuments.download')}
            />
          </ListGroup.Item>
        ))}
      </ListGroup>
    </div>
  );
};

export default CDDUserDocuments;
